import React from "react";
import './Body1.css';
import Box1 from "./Box1";
import picture8 from './source/picture8.png'
import picture9 from './source/picture9.png'
import picture10 from './source/picture10.png'



function Body1() {

  return (
    <div className="body1">
      <div className="body1-box1">
        <div className="body1-box2">
         <Box1 ImgBox1={picture8} NadpisBox1='Příprava projektu' PopisBox1='První setkání nad projektem. Detaily a úskalí projektu. Následuje zaměření místnosti.'/>
         <Box1 ImgBox1={picture9} NadpisBox1='Cenová nabídka' PopisBox1='Příprava cenové nabídky dle aktuálních ceníků na trhu s materiály.'/>
         <Box1 ImgBox1={picture10} NadpisBox1='Realizace' PopisBox1='Realizujeme dané práce v co nejkratším čase a k vaší spokojenosti.'/>
        </div>
      </div>
    </div>
  );
}

export default Body1;
